import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPhone, FiMail, FiMapPin, FiClock, FiFacebook, FiInstagram, FiTwitter } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center">
              <img 
                src="https://i.ibb.co/DPLWWytS/logo.jpg" 
                alt="Mr. Shaver Logo" 
                className="h-12 w-12 object-cover rounded-full border-2 border-[#826046]"
              />
              <div className="ml-3">
                <h3 className="text-lg font-bold text-[#826046]">Mr. Shaver</h3>
                <p className="text-sm text-gray-300">Gents Salon</p>
              </div>
            </div>
            <p className="text-gray-300 text-sm">
              Premium men's grooming services in Dubai. We provide professional haircuts, 
              beard trimming, and styling with expert barbers.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-300 hover:text-[#826046] transition-colors duration-200">
                <SafeIcon icon={FiFacebook} className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-300 hover:text-[#826046] transition-colors duration-200">
                <SafeIcon icon={FiInstagram} className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-300 hover:text-[#826046] transition-colors duration-200">
                <SafeIcon icon={FiTwitter} className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-[#826046]">Quick Links</h3>
            <ul className="space-y-2">
              {[
                { name: 'Home', path: '/' },
                { name: 'Services', path: '/services' },
                { name: 'Gallery', path: '/gallery' },
                { name: 'About Us', path: '/about' },
                { name: 'Contact Us', path: '/contact' }
              ].map((item) => (
                <li key={item.path}>
                  <Link 
                    to={item.path} 
                    className="text-gray-300 hover:text-[#826046] transition-colors duration-200 text-sm"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-[#826046]">Contact Info</h3>
            <div className="space-y-3">
              <div className="flex items-start">
                <SafeIcon icon={FiMapPin} className="w-5 h-5 text-[#826046] mr-3 mt-0.5 flex-shrink-0" />
                <p className="text-gray-300 text-sm">
                  Street 3 - Al Barsha South Third - Al Barsha South - Dubai - UAE
                </p>
              </div>
              <div className="flex items-center">
                <SafeIcon icon={FiPhone} className="w-5 h-5 text-[#826046] mr-3" />
                <a 
                  href="tel:+971501656278" 
                  className="text-gray-300 hover:text-[#826046] transition-colors duration-200 text-sm"
                >
                  +971 50 165 6278
                </a>
              </div>
              <div className="flex items-center">
                <SafeIcon icon={FiClock} className="w-5 h-5 text-[#826046] mr-3" />
                <p className="text-gray-300 text-sm">
                  Daily: 9:00 AM - 11:00 PM
                </p>
              </div>
            </div>
          </div>

          {/* Services */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-[#826046]">Our Services</h3>
            <ul className="space-y-2">
              {[
                'Haircuts & Styling',
                'Beard Trimming',
                'Hair Washing',
                'Face Treatments',
                'Hot Towel Service',
                'Traditional Shaving'
              ].map((service) => (
                <li key={service} className="text-gray-300 text-sm">
                  {service}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © 2025 Mr. Shaver Gents Salon. All rights reserved. | Designed with ❤️ for premium grooming experience.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;